// cart popup
$(".header__icon--cart").on("click", function (e) {
  e.preventDefault();
  $("#cart-notification").addClass("active");
});

// sort by show option on mobile
// var dynamic = document.getElementById('SortBy-mobile');
// dynamic.setAttribute('size', dynamic.childElementCount)

// bundle product

$(document).ready(function () {
  
  function subTotal (price_top,price_bottom,$selectedTotal,$selectedSaving,price_center, discountType){
    var quantity = $(".bundle--bottom .item-info.is-selected #Quantity").val();
    var subtotal = 0;
    var subtotal_sale = 0;
    let discount = 0
    var discountType = $("#main-bundle-kit").attr("discounttype");
  
    if($(".main-bundle--Customize-three").length > 0){
      subtotal = price_top + price_center + price_bottom;
    } else {
      subtotal = price_top + price_bottom;
    }

    if( discountType == "amountoff" ){
      discount = $("#main-bundle-kit").data("price")
    }else if(discountType == "percentageoff" ){
      let percentage = $("#main-bundle-kit").data("price");
      discount = Number(subtotal / 100) * Number(percentage);
    }
    
    if($(".main-bundle--Customize").length > 0){
      if(quantity > 1){
        subtotal_sale = subtotal - discount;
      } else{
        if($(".main-bundle--Customize-three").length > 0){
          subtotal_sale = subtotal - subtotal * 0.3;
        } else {
          subtotal_sale = subtotal - subtotal - discount;
        }
      }  
    } else {
      subtotal_sale = subtotal - discount;
    }

    var price_saving = subtotal - subtotal_sale;

    if(window.Shopify.currency.active == "VND") {
        $selectedTotal.text(Shopify.formatMoney(subtotal_sale).replace(".00" , "").replaceAll("," , ".")+" "+window.Shopify.currency.active )
    } else {
       $selectedTotal.text(Shopify.formatMoney(subtotal_sale))
    }
    console.log({subtotal_sale, price_saving})
  }

  if($(".main-bundle .bundle--top .bundle--image-top").length > 0){
    var flkty1 = new Flickity('.main-bundle .bundle--top .bundle--image-top', {
      prevNextButtons: false,
      wrapAround: true,
      contain: true,
      pageDots: true,
      cellAlign: 'center'
    });
  
    var flkty1_1 = new Flickity('.main-bundle .bundle--top .bundle--info-top', {
      asNavFor: '.main-bundle .bundle--top .bundle--image-top',
      pageDots: false,
      wrapAround: true,
      draggable: true,
      fade: true,
      prevNextButtons: false
    });

    flkty1_1.on('change', function (index) {
      flkty1.select(index);
    });
    $(".button-change--top").on('click', function() {
      flkty1.next();
    });
  }

  if($(".main-bundle .bundle--bottom .bundle--image-bottom").length > 0){
    var flkty2 = new Flickity('.main-bundle .bundle--bottom .bundle--image-bottom', {
      prevNextButtons: false,
      contain: true,
      pageDots: true,
      cellAlign: 'center',
      wrapAround: true
    });
  
    var flkty2_2 = new Flickity('.main-bundle .bundle--bottom .bundle--info-bottom', {
    asNavFor: '.main-bundle .bundle--bottom .bundle--image-bottom',
    pageDots: false,
    wrapAround: true,
    draggable: true,
    fade: true,
    prevNextButtons: false
  });

    flkty2_2.on('change', function (index) {
      flkty2.select(index);
    });
  
    $(".button-change--bottom").on('click', function() {
      flkty2.next();
    });
  }
  

  if($(".main-bundle--Customize-three").length > 0) {
    var flkty3 = new Flickity('.main-bundle .bundle--center .bundle--image-center', {
      prevNextButtons: false,
      wrapAround: true,
      contain: true,
      pageDots: true,
      cellAlign: 'center'
    });
  
    var flkty3_3 = new Flickity('.main-bundle .bundle--center .bundle--info-center', {
      asNavFor: '.main-bundle .bundle--center .bundle--image-center',
      pageDots: false,
      wrapAround: true,
      draggable: true,
      fade: true,
      prevNextButtons: false
    });
    flkty3_3.on('change', function (index) {
      flkty3.select(index);
    });
  
    $(".button-change--center").on('click', function() {
      flkty3.next();
    });
  }



  $('.main-bundle .bundle--top .bundle--image-top,.main-bundle .bundle--top .bundle--info-top,.main-bundle .bundle--bottom .bundle--image-bottom,.main-bundle .bundle--bottom .bundle--info-bottom,.main-bundle .bundle--center .bundle--image-center,.main-bundle .bundle--center .bundle--info-center').on( 'change.flickity', function( event, index ) {
    if ( event.namespace == 'flickity' ) {
      var price_top = parseFloat($(".bundle--info-top .is-selected .total .price").text()) * parseFloat($(".is-selected.item-info .box-product-form #Quantity").val());
      var price_bottom = parseFloat($(".bundle--info-bottom .is-selected .total .price").text()) * parseFloat($(".is-selected.item-info .box-product-form #Quantity").val());
      var $selectedTotal = $(".bundle--info-bottom .is-selected .sub_total .price");
      var discountType = $selectedTotal.attr("discounttype"); 
      var $selectedSaving = $(".bundle--info-bottom .is-selected .sub_total .price-saving");
      var price_center = 0;
      if($(".main-bundle--Customize-three").length > 0){
        price_center = parseFloat($(".bundle--info-center .is-selected .total .price").text()) * parseFloat($(".is-selected.item-info .box-product-form #Quantity").val());
      }
      
      subTotal(price_top,price_bottom,$selectedTotal,$selectedSaving,price_center, discountType);

      // $(".bundle--info-bottom .is-selected .product-form__buttons .custom-add-cart").on("click",function (e) {
      //   e.preventDefault();
      //   $(".bundle--info-top .is-selected button.product-form__submit").trigger("click")
      //   $(".bundle--info-bottom .is-selected button.product-form__submit").trigger("click")
      // })
    }
  });

  if($(".main-bundle--Customize").length > 0){
    if($(".main-bundle--Customize-three").length > 0){
      function syncSliders(index) {
        flkty1.off('change', syncSliders);
        flkty2.off('change', syncSliders);
        flkty3.off('change', syncSliders);
    
        flkty1.select(index);
        flkty2.select(index);
        flkty3.select(index);
    
        flkty1.on('change', syncSliders);
        flkty2.on('change', syncSliders);
        flkty3.on('change', syncSliders);
      }
    
      flkty1.on('change', syncSliders);
      flkty2.on('change', syncSliders);
      flkty3.on('change', syncSliders);
    } else{
      var selectingFromSlider1 = false;
      var selectingFromSlider2 = false;
    
      // Sync the sliders
      flkty1.on('select', function () {
        if (!selectingFromSlider2) {
          selectingFromSlider1 = true;
          flkty2.select(flkty1.selectedIndex);
          selectingFromSlider1 = false;
        }
      });
    
      flkty2.on('select', function () {
        if (!selectingFromSlider1) {
          selectingFromSlider2 = true;
          flkty1.select(flkty2.selectedIndex);
          selectingFromSlider2 = false;
        }
      });
    }
     
  }
  
  function sortArray(arr) {
      return arr.slice().sort((a, b) => a.trim().localeCompare(b.trim()));
  }

  function getPrice($selected) {
    let price = $selected.find(":selected").data("price");
    $selected.parents(".item-info").find(".total .price").text(price)
    let price_top = parseFloat($(".bundle--info-top .is-selected .total .price").text()) * parseFloat($(".is-selected.item-info .box-product-form #Quantity").val());
    let price_bottom = parseFloat($(".bundle--info-bottom .is-selected .total .price").text()) * parseFloat($(".is-selected.item-info .box-product-form #Quantity").val());
    var quantity = $(".bundle--bottom .item-info.is-selected #Quantity").val();
    var subtotal = 0;
    var subtotal_sale = 0;
    let discount = 0
    var discountType = $("#main-bundle-kit").attr("discounttype");
    if($(".main-bundle--Customize-three").length > 0){
      subtotal = price_top + price_center + price_bottom;
    } else {
      subtotal = price_top + price_bottom;
    }

    if( discountType == "amountoff" ){
      discount = $("#main-bundle-kit").data("price")
    }else if(discountType == "percentageoff" ){
      let percentage = $("#main-bundle-kit").data("price");
      discount = Number(subtotal / 100) * Number(percentage);
    }
  
    if($(".main-bundle--Customize").length > 0){
      if(quantity > 1){
        subtotal_sale = subtotal - discount;
      } else{
        if($(".main-bundle--Customize-three").length > 0){
          subtotal_sale = subtotal - subtotal * 0.3;
        } else {
          subtotal_sale = subtotal - subtotal - discount;
        }
      }  
    } else {
      subtotal_sale = subtotal - discount;
    }

    if($(window.Shopify.currency.active == "VND")) {
        $(".bundle--bottom .is-selected .sub_total .price").text(Shopify.formatMoney(subtotal_sale).replace(".00" , "").replaceAll("," , ".")+" "+window.Shopify.currency.active )
    } else {
       $(".bundle--bottom .is-selected .sub_total .price").text(Shopify.formatMoney(subtotal_sale))
    }

    console.log({subtotal_sale, subtotal, discount })
  }
  function getID(color,style,size,$selected) {

    var value = [];
    if(color == ""){
      value = `${style} / ${size}`
    } else if(style == ""){
      value = `${color} / ${size}`
    } else if(size == ""){
      value = `${color} / ${style}` 
    } else {
      value = `${color} / ${style} / ${size}`
    }

    var sortedArray1 = sortArray(value.split(" / "));
    $selected.parents(".item-info").find(".product-form__input--select select option").removeAttr("selected")
    $selected.find("option").each(function(){
        var $this = $(this);
        var arr = $(this).text().trim().split(" / ");
        var sortedArray2 = sortArray(arr);
      
        if (JSON.stringify(sortedArray1) === JSON.stringify(sortedArray2)) {
          if($this.attr("sold-out") == "sold-out"){
            $selected.parents(".item-info").find(".sold-out").fadeIn();
          } else {
            $selected.parents(".item-info").find(".sold-out").hide();
          }
          $selected.parents(".item-info").find(".box--add-cart input[name='id']").val($this.val())
          $selected.find(`option[value="${$this.val()}"]`).attr("selected","selected")
        }
    });
    var checkSoldOut = false;
    $(".bundle--info .item-info").each(function () {
      if($(this).hasClass("is-selected")){
        if($(this).find(".product-form__input--select select :selected").attr("sold-out") == "sold-out"){        
          checkSoldOut = true
          return false;
        }
      }
    })
    if(checkSoldOut){
      $(".box-product-form .custom-add-cart").addClass("disabled")
      $(".box-product-form .custom-add-cart").text($(".box-product-form .custom-add-cart").attr("atc-text"))
    } else {
      $(".box-product-form .custom-add-cart").removeClass("disabled")
      $(".box-product-form .custom-add-cart").text($(".box-product-form .custom-add-cart").attr("atc-text"))
    }
  }


  $( ".bundle--info .item-info" ).each(function( index ) {
    var $this = $(this);
    var color = "";
    var style = "";
    var size = "";
    if($this.find(".color-variant").length > 0){
      var color = $this.find(".color-variant input:checked").val();
    }
    if($this.find(".size-variant").length > 0){
      var size = $this.find(".size-variant input:checked").val();
    }
    if($this.find(".liner-variant").length > 0){
      var style = $this.find(".liner-variant input:checked").val();
    }
    var $selected = $this.find(".product-form__input--select select");
    getID(color,style,size,$selected)


  });

  $( ".bundle--info .item-info" ).each(function( index ) {
    var $this = $(this);

    $this.find(".liner-variant .item-variant input").on("click", function () {
      var color = "";
      var size = "";
      var $_this = $(this);
      var style = $(this).val();
      
      $this.find(".liner-variant input").removeAttr("checked")
      $this.find(".liner-variant select option").removeAttr("selected")
      $_this.parents(".item-variant").find("input").attr("checked","checked");
      $_this.parents(".item").find(`select option[value="${style}"]`).attr("selected","selected");

      if($this.find(".color-variant").length > 0){
        var color = $this.find(".color-variant input:checked").val();
      }
      if($this.find(".size-variant").length > 0){
        var size = $this.find(".size-variant input:checked").val();
      }
      var $selected = $this.find(".product-form__input--select select");
      getID(color,style,size,$selected);
      getPrice($selected)
    })

    $this.find(".liner-variant select").on("change", function () {
      var color = "";
      var size = "";
      var $_this = $(this);
      var style = $(this).val();
      
      $this.find(".liner-variant input").removeAttr("checked")
      $_this.parents(".item").find(`.item-variant input[value="${style}"]`).attr("checked","checked");
      
      $this.find(".liner-variant select option").removeAttr("selected")
      $_this.parents(".item").find(`select option[value="${style}"]`).attr("selected","selected");

      if($this.find(".color-variant").length > 0){
        var color = $this.find(".color-variant input:checked").val();
      }
      if($this.find(".size-variant").length > 0){
        var size = $this.find(".size-variant input:checked").val();
      }
      var $selected = $this.find(".product-form__input--select select");
      getID(color,style,size,$selected);
      getPrice($selected)
    })

    
    
    $this.find(".size-variant .item-variant input").on("click", function () {
      var $_this = $(this);
      var size = $(this).val();
      var color = "";
      var style = "";
      $this.find(".size-variant input").removeAttr("checked")
      $_this.parents(".item-variant").find("input").attr("checked","checked");
      
      $this.find(".size-variant select option").removeAttr("selected")
      $_this.parents(".item").find(`select option[value="${size}"]`).attr("selected","selected");
      
      if($this.find(".color-variant").length > 0){
        var color = $this.find(".color-variant input:checked").val();
      }
      if($this.find(".liner-variant").length > 0){
        var style = $this.find(".liner-variant input:checked").val();
      }
      var $selected = $this.find(".product-form__input--select select");
      getID(color,style,size,$selected);
      getPrice($selected)
    })

    $this.find(".size-variant select").on("change", function () {
      var $_this = $(this);
      var size = $(this).val();
      var color = "";
      var style = "";
      
      $this.find(".size-variant input").removeAttr("checked")
      $_this.parents(".item").find(`.item-variant input[value="${size}"]`).attr("checked","checked");
      
      $this.find(".size-variant select option").removeAttr("selected")
      $_this.parents(".item").find(`select option[value="${size}"]`).attr("selected","selected");

      if($this.find(".color-variant").length > 0){
        var color = $this.find(".color-variant input:checked").val();
      }
      if($this.find(".liner-variant").length > 0){
        var style = $this.find(".liner-variant input:checked").val();
      }
      var $selected = $this.find(".product-form__input--select select");
      getID(color,style,size,$selected);
      getPrice($selected)
    })

    $this.find(".color-variant .item-variant a").on("click", function (e) {
      e.preventDefault();
      $_this = $(this);
      $this.find(".color-variant input").removeAttr("checked")
      $_this.parents(".item-variant").find("input").attr("checked","checked");
      if($_this.parents(".limited-editions").length == 1){
        $_this.parents(".color-variant").find(".form__label .color_val.color_val-limited").text($_this.parents("label").prev().val());
        $_this.parents(".color-variant").find(".form__label .color_val:not(.color_val-limited)").text("");
      }else{
        $_this.parents(".color-variant").find(".form__label .color_val:not(.color_val-limited)").text($_this.parents("label").prev().val());
        $_this.parents(".color-variant").find(".form__label .color_val.color_val-limited").text("");
        // closestLimitedLabel.text("");
      }
      var url = $_this.attr("href");

      fetch(url).then(function (response) {
      	// The API call was successful!
      	return response.text();
      }).then(function (html) {
      
      	// Convert the HTML string into a document object
      	var parser = new DOMParser();
      	var doc = parser.parseFromString(html, 'text/html');

        $_this.parents(".item-info").find(".product-form__input--select").html($(doc).find(".info-hidden .form-custom .product-form__input--select").html())
        const productID = $this.data("id");
        $_this.parents(".bundle").find(`.image--${productID} img`).attr("src",$(doc).find(".product__media-list .product__media-item.is-active img").attr("src"))

      }).then(function(params) {
        var color = "";
        var style = "";
        var size = "";
        if($this.find(".color-variant").length > 0){
          var color = $this.find(".color-variant input:checked").val();
        }
        if($this.find(".size-variant").length > 0){
          var size = $this.find(".size-variant input:checked").val();
        }
        if($this.find(".liner-variant").length > 0){
          var style = $this.find(".liner-variant input:checked").val();
        }
        var $selected = $this.find(".product-form__input--select select");

        getID(color,style,size,$selected);
        getPrice($selected)
      }).catch(function (err) {
      	// There was an error
      	console.warn('Something went wrong.', err);
      });
    })

    $this.find(".product-form__quantity quantity-input .quantity__button").on("click",function () {
      var $this = $(this)
      var quantity = $this.parents(".quantity").find("input[name='quantity']").val();
      $(".is-selected.item-info .box-product-form #Quantity").val(quantity);
      var price_top = parseFloat($(".bundle--info-top .is-selected .total .price").text()) * parseFloat($(".is-selected.item-info .box-product-form #Quantity").val());
      var price_bottom = parseFloat($(".bundle--info-bottom .is-selected .total .price").text()) * parseFloat($(".is-selected.item-info .box-product-form #Quantity").val());
      var $selectedTotal = $(".bundle--info-bottom .is-selected .sub_total .price");
      var $selectedSaving = $(".bundle--info-bottom .is-selected .sub_total .price-saving");

      var price_center = 0;
      if($(".main-bundle--Customize-three").length > 0){
        price_center = parseFloat($(".bundle--info-center .is-selected .total .price").text()) * parseFloat($(".is-selected.item-info .box-product-form #Quantity").val());
      }
      
      subTotal(price_top,price_bottom,$selectedTotal,$selectedSaving,price_center);
      
    })
    
  });

  if($(".main-bundle").length > 0){
    var price_top = parseFloat($(".bundle--info-top .is-selected .total .price").text());
    var price_center = 0;
    if($(".main-bundle--Customize-three").length > 0){
      price_center = parseFloat($(".bundle--info-center .is-selected .total .price").text());
    }
    var price_bottom = parseFloat($(".bundle--info-bottom .is-selected .total .price").text());
    var $selectedTotal = $(".bundle--info-bottom .is-selected .sub_total .price");
    var $selectedSaving = $(".bundle--info-bottom .is-selected .sub_total .price-saving");

    subTotal(price_top,price_bottom,$selectedTotal,$selectedSaving,price_center)
  }
  
  $(".bundle--info-bottom ").on("click",".is-selected .product-form__buttons .custom-add-cart", function (e) {
    e.preventDefault();
    $(".bundle--info-top .is-selected .product-form__buttons button.product-form__submit").trigger("click")
    setTimeout(() => {
      $(".bundle--info-bottom .is-selected .product-form__buttons button.product-form__submit").trigger("click")
    }, 1000);
    
    $(".bundle--info-center .is-selected .product-form__buttons button.product-form__submit").trigger("click")
  })

  $(".bundle-header .select select").on("change",function (e) {
    e.preventDefault();
    var value = $(this).val();
    window.location.href = value;
  })

  // Optimalisation: Store the references outside the event handler:
    var $window = $(window);


    function checkWidth() {
        var windowsize = $window.width();
        if (windowsize < 768) {
            $('.main-bundle .list-pack').flickity({
              pageDots: true,
              prevNextButtons: false
            });
        }
    }
    // Execute on load
    checkWidth();
    // Bind event listener
    $(window).resize(checkWidth);

    $("#upCart").on("click",".upcart-header-close-button",function () {
      $("body").removeClass("overflow-hidden")      
    })

    $(".bundle .choose_this_kit").on("click",function (e) {
      e.preventDefault();
      $(".choose_this_kit").hide();
      $(".bundle--image").hide()
      $(".bundle--info .box--hide").fadeIn();
      $(".main-bundle .bundle--info-bottom .item-info .box--add-cart").fadeIn();
      $(".bundle--info").flickity().flickity('resize');
    })


      
    // Bundle Save

    if($(".product__info-wrapper").length > 0){

      function handleCheck() {
         if ($(".box-content .list-product .item.is-active").length > 1) {
            $(".product-form--main .product-form__buttons .custom-addCart").removeClass("disabled");
            $(".product-form--main .product-form__buttons .custom-addCart").text("Add to cart");
            $(".bundle_price").show();
         } else {
            $(".product-form--main .product-form__buttons .custom-addCart").addClass("disabled");
            $(".product-form--main .product-form__buttons .custom-addCart").text("add at least 2 items");
            $(".bundle_price").hide();
         }
      }
      function updatePrice($this, newPrice) {
        return new Promise((resolve, reject) => {
          try {
            $this.parents(".item").data("price", newPrice).attr("data-price", newPrice);
            resolve();
          } catch (error) {
            reject(error);
          }
        });
      }
      function setPrice() {
         let discount_first = $("#tabs-content-bundle").data("discount-first")
         let discount_second = $("#tabs-content-bundle").data("discount-second")
         if ($(".box-content .list-product .item.is-active").length == 2) {
            $(".tabs-bundle  .bundle_price .price .save .count").text(discount_first / 100)
         } else if ($(".box-content .list-product .item.is-active").length == 3) {
            $(".tabs-bundle .bundle_price .price .save .count").text(discount_second / 100)
         } else {
            $(".tabs-bundle  .bundle_price .price .save .count").text(discount_first / 100)
         }
        
         var countryCode = getCountryCode();
         var totalPrice = 0;
        
         $(".product__info-container .list-product .item.is-active").each(function () {
            var $this = $(this);
            console.log($this.data("price"))
            totalPrice += $this.data("price");
         })
      
         if ($(".box-content .list-product .item.is-active").length == 2) {
            totalPrice = totalPrice - discount_first;
         } else if ($(".box-content .list-product .item.is-active").length == 3) {
            totalPrice = totalPrice - discount_second;
         } else {
            totalPrice = totalPrice - discount_first;
         }
         // Format the price using the custom format function
         var formattedPrice = formatMoneyByCountry(totalPrice, countryCode);
      
         $(".tabs-bundle .bundle_price .price .money").text(formattedPrice)
         
      }
      
      // Show the first tab and hide the rest
      $('.tabs-bundle #tabs-nav-bundle li:first-child').addClass('active');
      $('.tabs-bundle .tab-content').hide();
      $('.tabs-bundle .tab-content:first').show();
      
      // Click function
      $('.tabs-bundle #tabs-nav-bundle li').click(function () {
         var $this = $(this);
         $('#tabs-nav-bundle li').removeClass('active');
         $(this).addClass('active');
         $('.tab-content').hide();
      
         var activeTab = $(this).find('a').attr('href');
         if (activeTab == "#tab2") {
            $(".product-form--main .product-form__buttons .custom-addCart").show();
            $(".product-form--main .product-form__buttons .product-form__submit").hide();
            handleCheck()
         } else {
            $(".product-form--main .product-form__buttons .custom-addCart").hide();
            $(".product-form--main .product-form__buttons .product-form__submit").show();
         }
         $(activeTab).fadeIn();
         return false;
      });
      
      var listURL = [];

      
      $(".tabs-bundle").on("click", ".list-product .item .action-product", function (e) {
         e.preventDefault();
         var $this = $(this)
         var ID = $this.parents(".item").data("id");
         
         $this.parents(".item").find(".image-product").hide();
         $(`.list-product-addCart .item--${ID}`).addClass("is-active")
         $this.parents(".item").addClass("is-active");
         var variant_ID = $(".product-form--main input[name='id']").val()
         var image = $(".product__media-wrapper .image-main").attr("src")
         $(`.list-product-addCart .item--${ID} input[name='id']`).val(variant_ID)
         $this.parents(".item").find(".info-product .title").attr("data-id", variant_ID)
        $this.parents(".item").find(".info-product .title").text($(".product__title h1").text())
         $this.parents(".item").find(".image-product").attr("src", image)
         $this.parents(".item").find(".image-product").fadeIn();
         $this.parents(".item").find(".info-product .variant").text($(".info-hidden .product-form__input--select .select__select :selected").text())
         handleCheck();
         let newPrice = $(".info-hidden .product-form__input--select .select__select :selected").data("price")
         updatePrice($this, newPrice)
          .then(() => {
            setPrice();
          })
          .catch((error) => {
            console.error("Lỗi khi cập nhật giá trị:", error);
          });
         var productURL = $(".product__title .product__title").attr("href");
         listURL.push(`${productURL}?variant=${variant_ID}`)
      })
      $(".tabs-bundle").on("mouseenter", ".list-product .item.is-active", function () {
         $(this).find(".info-product").html();
         $(".infoProduct").html($(this).find(".info-product").html())
         $(".infoProduct").addClass("active")
      })
      $(".tabs-bundle").on("mouseleave", ".box-content", function () {
         $(".infoProduct").html("")
         $(".infoProduct").removeClass("active")
      })
      $(".tabs-bundle").on("click", ".list-product .item.is-active .button-remove", function (e) {
         e.preventDefault();
         var $this = $(this)
         var ID = $this.data("id");
         $(".infoProduct").html("");
         $(`.tabs-bundle .list-product .item--${ID}`).removeClass("is-active");
         $(`.list-product-addCart .item--${ID}`).removeClass("is-active");
         handleCheck();
         setPrice(); 
         var IDRemove = $(`.list-product-addCart .item--${ID} input[name="id"]`).val();
      
         listURL.map(function (url, i) {
            if (url.includes(IDRemove)) {
               listURL.splice(i, 1);
               return false
            }
         })
      })
      $(".tabs-bundle").on("click", ".infoProduct .remove", function (e) {
         e.preventDefault();
         var $this = $(this)
         var ID = $this.data("id");
         $(".infoProduct").html("");
         $(`.tabs-bundle .list-product .item--${ID}`).removeClass("is-active");
         $(`.list-product-addCart .item--${ID}`).removeClass("is-active");
         handleCheck();
         setPrice();
         var IDRemove = $(`.list-product-addCart .item--${ID} input[name="id"]`).val();
      
         listURL.map(function (url, i) {
            if (url.includes(IDRemove)) {
               listURL.splice(i, 1);
               return false
            }
         })
      })

      $("body").on("click", ".custom-addCart", function (e) {
        e.preventDefault();
        let newVariantIdArray = []
        $(".product__info-container .list-product-addCart .item.is-active").each(function () {
         newVariantIdArray.push($(this).find(`input[name="id"]`).val())
        });
        let product_data = newVariantIdArray.map(variantId => {
          return {quantity: 1, id: variantId}
        })
        var data = {
          items: product_data
        }
        fetch('/cart/add.js', {
          body: JSON.stringify(data),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
          },
          method: 'POST'
        }).then((response) => {
          return response.json();
        }).then((json) => {
          /* yay! our products were added - do something here to indicate to the user */
          console.log('products', json)
        }).catch((err) => {
          /* uh oh, we have error. */
          console.error(err)
        });
      })


      // product page new 

      function getVariantID(color,style,size) {
        let countryCode = getCountryCode();
        let value = [];
        if(color == ""){
          value = `${style} / ${size}`
        } else if(style == ""){
          value = `${color} / ${size}`
        } else if(size == ""){
          value = `${color} / ${style}` 
        } else {
          value = `${color} / ${style} / ${size}`
        }

        let sortedArray1 = sortArray(value.split(" / "));

        $(".info-hidden .product-form__input--select select option").removeAttr("selected")
        $(".section--main-product .modal-notify #variant_select select option").removeAttr("selected")
        
        $(".info-hidden .product-form__input--select select").find("option").each(function(){
            let $this = $(this);
            let arr = $(this).text().trim().split(" / ");
            let sortedArray2 = sortArray(arr);
            if (JSON.stringify(sortedArray1) === JSON.stringify(sortedArray2)) {
              if($this.attr("sold-out") == "sold-out"){
                $(".product-form--main .button-notify").show();
                $(".product-form--main .product-form__submit span").text("Sold out");
                $(".product-form--main .product-form__submit").attr("disabled","disabled");
                $(".tabs-bundle .item:not(.is-active)").addClass("disabled")
              } else {
                $(".product-form--main .product-form__submit span").text($(".product-form--main .product-form__submit span").attr("soldout-text"));
                $(".product-form--main .button-notify").hide();
                $(".product-form--main .product-form__submit").removeAttr("disabled");
                $(".tabs-bundle .item:not(.is-active)").removeClass("disabled")
              }
              $(".product-form--main .form input[name='id']").val($this.val());
              $(".custom_scroll_variant .form input[name='id']").val($this.val())
              $(".info-hidden .product-form__input--select select").find(`option[value="${$this.val()}"]`).attr("selected","selected")
              let price = $(".info-hidden .product-form__input--select select").find(`option[value="${$this.val()}"]`).data("price");
              let formattedPrice = formatMoneyByCountry(price, countryCode);
              $(".product__info-container .price .price__regular .price-item--regular").text(formattedPrice)
            }
        });

        $(".section--main-product .modal-notify #variant_select select").find("option").each(function(){
            let $this = $(this);
            let arr = $(this).text().trim().split(" / ");
            let sortedArray2 = sortArray(arr);

            if (JSON.stringify(sortedArray1) === JSON.stringify(sortedArray2)) {
              $(".section--main-product .modal-notify #variant_select select").find(`option[value="${$this.val()}"]`).attr("selected","selected")
            }
        });
      }

      // color
      $(".product__info-wrapper").on("click",".color-variant a", function (e) {
        console.log("...")
        e.preventDefault();
        let $_this = $(this);
        let url = $_this.attr("href");

        window.history.pushState("", "", url);

        $(".custom_scroll_variant").find("input").prop("checked", false).removeAttr("checked")
        $_this.parents(".color-variant").find("input").prop("checked", false).removeAttr("checked")
        $_this.parents("label").prev().prop("checked", true).attr("checked","checked");
        let selectedInputId = $_this.parents("label").prev().attr("id");
        $(".custom_scroll_variant").find("input").filter(function() {
          return this.id === selectedInputId;
        }).prop("checked", true).attr("checked","checked")
        
        if($_this.parents(".limited-editions").length == 1){
          $_this.parents(".color-variant").find(".form__label .color_val.color_val-limited").text($_this.parents("label").prev().val());
          $_this.parents(".color-variant").find(".form__label .color_val:not(.color_val-limited)").text("");
        }else{
          $_this.parents(".color-variant").find(".form__label .color_val:not(.color_val-limited)").text($_this.parents("label").prev().val());
          $_this.parents(".color-variant").find(".form__label .color_val.color_val-limited").text("");
          // closestLimitedLabel.text("");
        }

        fetch(url).then(function (response) {
        	// The API call was successful!
        	return response.text();
        }).then(function (html) {
          // Convert the HTML string into a document object
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          $(".form-custom .product-form__input--select").html($(doc).find(".info-hidden .form-custom .product-form__input--select").html());
          $(".product .product__media-wrapper").html($(doc).find(".product .product__media-wrapper").html());
          $(".product .section--main-product .modal-notify").html($(doc).find(".section--main-product .modal-notify").html());
          $(".product .section--main-product .box-price--main").html($(doc).find(".section--main-product .box-price--main").html());
          
        }).then(function(params) {
          let color = "";
          let style = "";
          let size = "";
          if($_this.parents(".list-variants").find(".color-variant").length > 0){
            color = $_this.parents(".list-variants").find(".color-variant input:checked").val();
          }
          if($_this.parents(".list-variants").find(".size-variant").length > 0){
            size = $_this.parents(".list-variants").find(".size-variant input:checked").val();
          }
          if($_this.parents(".list-variants").find(".liner-variant").length > 0){
            style = $_this.parents(".list-variants").find(".liner-variant input:checked").val();
          }
          getVariantID(color,style,size);
          function adjustThumbnail(){
              let screenSize = window.screen.width;
              if(screenSize > 750){
                  let productMainSlider = document.querySelector(".product-main-slider");
                  let productMainSliderHeight = productMainSlider.clientHeight;
                  document.querySelector("slider-component.thumbnail-slider").style.height = productMainSliderHeight+"px";   
                  console.log({productMainSliderHeight});
              }else{
                  document.querySelector("slider-component.thumbnail-slider").style.height = "auto"; 
              }
          }
          adjustThumbnail();
        }).catch(function (err) {
        	// There was an error
        	console.warn('Something went wrong.', err);
        });
      })
      $(".custom_scroll_variant").on("click",".option-color a", function (e) {
        e.preventDefault();
        let $_this = $(this);
        let url = $_this.attr("href");
        $_this.parents(".card_swacthes-custom").find("input").removeAttr("checked")
        $(".product__info-wrapper .list-variants .color-variant").find("input").removeAttr("checked")
        $_this.parents("label").prev().attr("checked","checked");
        $(".product__info-wrapper .list-variants .color-variant").find(`input[value="${$_this.parents("label").prev().val()}"]`).attr("checked","checked")
        fetch(url).then(function (response) {
        	// The API call was successful!
        	return response.text();
        }).then(function (html) {
          // Convert the HTML string into a document object
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          $(".form-custom .product-form__input--select").html($(doc).find(".info-hidden .form-custom .product-form__input--select").html());
          $(".product .product__media-wrapper").html($(doc).find(".product .product__media-wrapper").html())
          
        }).then(function(params) {
          let color = "";
          let style = "";
          let size = "";
          if($(".product__info-wrapper .list-variants").find(".color-variant").length > 0){
            color = $(".product__info-wrapper .list-variants").find(".color-variant input:checked").val();
          }
          if($(".product__info-wrapper .list-variants").find(".size-variant").length > 0){
            size = $(".product__info-wrapper .list-variants").find(".size-variant input:checked").val();
          }
          if($(".product__info-wrapper .list-variants").find(".liner-variant").length > 0){
            style = $(".product__info-wrapper .list-variants").find(".liner-variant input:checked").val();
          }
          getVariantID(color,style,size)

          function adjustThumbnail(){
              let screenSize = window.screen.width;
              if(screenSize > 750){
                  let productMainSlider = document.querySelector(".product-main-slider");
                  let productMainSliderHeight = productMainSlider.clientHeight;
                  document.querySelector("slider-component.thumbnail-slider").style.height = productMainSliderHeight+"px";   
                  console.log({productMainSliderHeight});
              }else{
                  document.querySelector("slider-component.thumbnail-slider").style.height = "auto"; 
              }
          }
          adjustThumbnail();
        }).catch(function (err) {
        	// There was an error
        	console.warn('Something went wrong.', err);
        });
      })

      // size
      $(".product__info-wrapper").on("click",".size-variant label", function () {
        let $_this = $(this);
        let size = $_this.prev().val();
        let color = "";
        let style = "";
        
        $_this.parents(".size-variant").find("input").removeAttr("checked")
        $_this.prev().attr("checked","checked");
        $_this.parents(".size-variant").find(".form__label .value").text($_this.prev().val());
        
        $(".custom_scroll_variant .option-size select option").removeAttr("selected")
        $(".custom_scroll_variant .option-size select").find(`option[value="${size}"]`).attr("selected","selected")
        
        if($_this.parents(".list-variants").find(".color-variant").length > 0){
          color = $_this.parents(".list-variants").find(".color-variant input:checked").val();
        }
        if($_this.parents(".list-variants").find(".liner-variant").length > 0){
          style = $_this.parents(".list-variants").find(".liner-variant input:checked").val();
        }
        getVariantID(color,style,size);
      })
      $(".custom_scroll_variant").on("change",".option-size select", function () {
        let $_this = $(this);
        let size = $_this.val();
        let color = "";
        let style = "";
        
        $_this.find("option").removeAttr("selected")
        $_this.find(`option[value="${size}"]`).attr("selected","selected")
        
        $(".product__info-wrapper .size-variant").find("input").removeAttr("checked")
        $(".product__info-wrapper .size-variant").find(`input[value="${size}"]`).attr("checked","checked")

        if($(".product__info-wrapper .list-variants").find(".color-variant").length > 0){
          color = $(".product__info-wrapper .list-variants").find(".color-variant input:checked").val();
        }
        if($(".product__info-wrapper .list-variants").find(".liner-variant").length > 0){
          style = $(".product__info-wrapper .list-variants").find(".liner-variant input:checked").val();
        }
        getVariantID(color,style,size);
      })

      // Style
      $(".product__info-wrapper").on("click",".liner-variant label", function () {
        let $_this = $(this);
        let style = $_this.prev().val();
        let color = "";
        let size = "";
        
        $_this.parents(".liner-variant").find("input").removeAttr("checked")
        $_this.prev().attr("checked","checked");
        $_this.parents(".liner-variant").find(".form__label .value").text($_this.prev().val());
        
        $(".custom_scroll_variant .option-style select option").removeAttr("selected")
        $(".custom_scroll_variant .option-style select").find(`option[value="${style}"]`).attr("selected","selected")
        
        if($_this.parents(".list-variants").find(".color-variant").length > 0){
          color = $_this.parents(".list-variants").find(".color-variant input:checked").val();
        }
        if($_this.parents(".list-variants").find(".size-variant").length > 0){
          size = $_this.parents(".list-variants").find(".size-variant input:checked").val();
        }
        getVariantID(color,style,size);
      })
      $(".custom_scroll_variant").on("change",".option-style select", function () {
        let $_this = $(this);
        let style = $_this.val();
        let color = "";
        let size = "";
        
        $_this.find("option").removeAttr("selected")
        $_this.find(`option[value="${size}"]`).attr("selected","selected")
        
        $(".product__info-wrapper .liner-variant").find("input").removeAttr("checked")
        $(".product__info-wrapper .liner-variant").find(`input[value="${size}"]`).attr("checked","checked")

        if($(".product__info-wrapper .list-variants").find(".color-variant").length > 0){
          color = $(".product__info-wrapper .list-variants").find(".color-variant input:checked").val();
        }
        if($(".product__info-wrapper .list-variants").find(".size-variant").length > 0){
          size = $(".product__info-wrapper .list-variants").find(".size-variant input:checked").val();
        }
        getVariantID(color,style,size);
      })
    }
    $(".product-form--main").on("click",".button-notify", function (e) {
      e.preventDefault();
      $(".modal-notify").addClass("is-active") 
    })
    $("body").on("click",".modal-notify .close-notify", function (e) {
      e.preventDefault();
      $(".modal-notify form #email").val("");
      $(".modal-notify form .btn-success").show();
      $("#completed_message").hide();
      $(".modal-notify").removeClass("is-active") 
    })
    $("body").on("click",".modal-notify", function (e) {
      e.preventDefault();
      if(!e.target.closest(".box-content")){
        $(".modal-notify form #email").val("");
        $(".modal-notify form .btn-success").show();
        $("#completed_message").hide();
        $(".modal-notify").removeClass("is-active")
      } 
    })
    $("body").on("click",".modal-notify .box-content form .btn-success", function (e) {
      e.preventDefault();
      let $this = $(this);
      let token = "N4qupF";
      let email = $this.parents("form").find("#email").val();
      let variant = $this.parents("form").find("#variant_select select").val();
      $.ajax({
          type: "POST",
          url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
          data: {
              a: token, // Klaviyo account public token
              email: email, // Email address entered in form
              variant: variant, // ID of the out of stock product variant about which customer wants to be notified.
              platform: "shopify"
          },
          success: function(response){
              $this.hide();
              $("#completed_message").fadeIn();
          },
          error: function(error) {
             $("#error_message").fadeIn();
          }
      })
    })


    $('.section--image-with-text .list-product--mobile').flickity({
      freeScroll: true,
      contain: true,
      prevNextButtons: false,
      pageDots: false
    });
  
    let maxHeight = 0;
    $("#shopify-section-template--22932183023894__custom_image_with_text_Yjm3Mx .list-product--mobile .item").each(function () {
      const itemHeight = $(this).find(".box-item--text").innerHeight();
      if (itemHeight > maxHeight) {
        maxHeight = itemHeight;
      }
    })
    $("#shopify-section-template--22932183023894__custom_image_with_text_Yjm3Mx .list-product--mobile .item .box-item--text").css("height", maxHeight)
    

});